import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app, {
    onRecoverableError: (err, info) => {
      console.warn("HYDRATION_RECOVERABLE:", err && err.message, info && info.componentStack);
    },
  });
} else {
  createRoot(rootElement).render(app);
}
